import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import { GetManageTeamsResponse } from '@App/manage-users/models/get-manage-teams-response.interface';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface PerformanceAccount {
    parentAccountId: string;
    name: string;
    code: string;
}

@Component({
    selector: 'dashboard-header-component',
    templateUrl: './dashboard-header.component.html',
    styleUrl: './dashboard-header.component.scss',
    imports: [SharedModule, MatFormFieldModule, MatSelectModule]
})
export class DashboardHeaderComponent implements OnChanges {
    @Input() userName: string;
    @Input() teams: GetManageTeamsResponse[];
    @Input() teamId: string;
    @Input() clientId: string;
    @Input() isSupervisorDashboardEnabled: boolean = false;
    @Input() accounts: PerformanceAccount[] = [];
    @Input() accountFilter: string[] = [];
    @Input() isAccountFilterEnabled: boolean = false;
    @Output() teamValueEmitted = new EventEmitter<string>();
    @Output() accountValueEmitted = new EventEmitter<string[]>();

    accountFilterModel: string[] = ['all-accounts'];

    constructor() { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['accounts']) {
            this.syncAccountFilterModel();
        } else if (changes['accountFilter'] && this.accountFilter.length > 0) {
            this.accountFilterModel = [...this.accountFilter];
        }
    }

    private allAccountIds(): string[] {
        return (this.accounts ?? []).map(a => a.parentAccountId);
    }

    private syncAccountFilterModel(): void {
        this.accountFilterModel = this.accountFilter.length === 0
            ? ['all-accounts', ...this.allAccountIds()]
            : [...this.accountFilter];
    }

    get accountFilterLabel(): string {
        if (!this.accountFilter || this.accountFilter.length === 0) {
            return `All Accounts (${this.accounts?.length ?? 0})`;
        }
        if (this.accountFilter.length === 1) {
            const account = this.accounts.find(a => a.parentAccountId === this.accountFilter[0]);
            return account ? `${account.name} (${account.code})` : `All Accounts (${this.accounts?.length ?? 0})`;
        }
        return `Multiple (${this.accountFilter.length})`;
    }

    onTeamChange(teamId: string) {
        this.teamValueEmitted.emit(teamId);
    }

    onAccountChange(selected: string[]) {
        const wasAllSelected = this.accountFilterModel.includes('all-accounts');
        const isAllSelected = selected.includes('all-accounts');

        if (isAllSelected && !wasAllSelected) {
            this.accountFilter = [];
        } else if (!isAllSelected && wasAllSelected) {
            this.accountFilter = [];
            this.accountFilterModel = [];
            this.accountValueEmitted.emit(this.accountFilter);
            return;
        } else {
            const ids = selected.filter(id => id !== 'all-accounts');
            this.accountFilter = ids.length === this.allAccountIds().length ? [] : ids;
        }

        this.syncAccountFilterModel();
        this.accountValueEmitted.emit(this.accountFilter);
    }
}
